var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDataReportingAssistantChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "data-reporting-assistant-chat_svg__svg-safari-fix",
  viewBox: "0 0 40 40",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#data-reporting-assistant-chat_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "data-reporting-assistant-chat_svg__b",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#data-reporting-assistant-chat_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.833,
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.333
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BEBEFE",
  d: "M93.576 26.39h-36.11c-1.11 0-2.197.9-2.425 2.01l-4.088 19.806c-.23 1.11.485 2.01 1.596 2.01h36.11c1.11 0 2.196-.9 2.425-2.01L95.17 28.4c.23-1.11-.485-2.01-1.595-2.01"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5353E4",
  d: "M51.949 37.682s2.382-1.724 5.46-.738c3.077.987 3.995-.8 2.581-1.892-1.415-1.093-3.102-1.49-3.35-1.514-.25-.024-.426.075-1.752.472s-1.748.248-2.94.471a13 13 0 0 0-1.985.521l1.985 2.68"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09CFAF",
  d: "M60.997 21.476h36.11c1.111 0 1.825.9 1.597 2.01l-4.088 19.806c-.23 1.11-1.315 2.01-2.425 2.01H56.08c-1.111 0-1.825-.9-1.597-2.01l4.089-19.806c.229-1.11 1.314-2.01 2.424-2.01"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M75.738 33.39c-.917 4.44-5.26 8.04-9.701 8.04s-7.298-3.6-6.382-8.04c.917-4.442 5.26-8.042 9.701-8.042s7.298 3.6 6.382 8.041"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.606,
  d: "M64.32 35.168c-.095-.168-1.564-1.527-.188-3.146 1.377-1.62 1.746.465 1.759.41.01-.057.057-2.532 1.6-2.886s1.226 2.81 1.226 2.81 1.5-1.86 2.323-1.154c.822.707-.557 1.433-.557 1.433s1.579 1.005.256 1.825M66.08 36.73s1.019 1.191 2.27 0M83.04 27.711h9.73M79.004 31.639H91.96M78.194 35.567h8.215M77.381 39.495h12.955"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.606,
  d: "m57.178 37.02-.882 5.928c-.167 1.121.596 1.98 1.705 1.917l36.054-2.017c1.108-.062 2.143-1.021 2.309-2.143l2.975-20.002c.167-1.122-.596-1.98-1.705-1.918L61.58 20.802c-1.109.062-2.143 1.021-2.309 2.143l-.67 4.512"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5353E4",
  d: "M-7.824 44.42c-.1-.025-1.105-1.613-2.557-1.364s-5.113.683-5.162.26c-.05-.422.484-.483.484-.483s-1.551.012-1.576-.36c-.025-.373.77-.609.77-.609s-1.365.037-1.316-.509c.05-.546 1.29-.471 1.29-.471s-.744-.298-.707-.856c.037-.559 5.473-.646 6.775-.51 1.304.138 3.202 1.626 3.202 1.626zM51.627 33.86s1.688-.173 4.816-2.01c3.127-1.836 3.375-1.39 2.68-.272s-1.588.695-2.036 1.812c-.446 1.117-1.415 2.433-2.903 2.134-1.489-.298-3.847 1.421-3.847 1.421l1.29-3.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09CFAF",
  d: "M32.127 108.812h-7.54c-.302-.865-.32-2.165.535-3.5 1.464-2.283 0-4.616 0-4.616l4.566 1.142s-.992 3.127.745 4.69a7.3 7.3 0 0 1 1.694 2.284M14.499 105.536c-.112 1.191-.628 2.382-1.115 3.276H6.068c-.258-.703-.356-1.578.514-1.936 1.564-.645 4.219-4.864 4.393-7.446.174-2.58 3.202 2.11 3.202 2.11s.546 1.613.323 3.996z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09CFAF",
  d: "M52.403 36.637s-9.325 6.645-11.447 6.757c-2.122.111-13.738-9.605-13.738-9.605s1.006 13.402 1.23 15.244c.034.287.15 1.121.326 2.334.95 6.578 3.596 24.272 3.974 25.922.446 1.955-2.234 23.23-2.737 24.57s-5.92-1.732-5.92-1.732 1.62-19.04 1.51-21.163c-.113-2.122-3.687-13.57-3.687-13.57s-5.36 31.328-6.87 34.343c-1.507 3.015-5.974-1.005-5.974-1.005s1.451-6.7 2.178-9.996c.727-3.294 1.675-31.383 1.787-33.671.02-.41-.024-1.24-.111-2.326-.397-4.973-1.676-15.32-1.676-15.32-.39 4.189-3.574 12.118-5.919 12.844S-9.078 44.567-9.358 43.73s1.843-5.919 1.843-5.919l11 5.137 1.062-6.645c.577-3.614 1.95-7.599 4.691-10.15 3.39-3.154 9.323-2.313 13.563-1.597 3.029.511 6.03 1.456 8.68 3.032 2.809 1.67 5.015 4.238 7.434 6.403.431.386.861.773 1.3 1.148.113.097.406.438.572.438.335 0 11.224-5.529 11.224-5.529 1.62 2.122.391 6.59.391 6.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5353E4",
  d: "M-10.17 41.22c-.123.011-1.738.397-1.998-.87s-1.29-2.63-.794-3.089 3.437 3.028 3.437 3.028z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.606,
  d: "m27.106 30.605.463 9.508M9.74 31.137l1.274 9.528M-7.516 39.513 4.937 45.3M3.742 42.143s-.21-6.165 3.647-12.974c3.859-6.808 17.596-4.52 21.896-2.286s11.503 9.493 11.503 9.493M40.453 37.683l9.511-4.896"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.606,
  d: "m21.472 32.635 3.326.124s.918 3.649-1.067 3.996-2.929-3.177-2.259-4.12zM15.417 100.406s3.13-15.725 4.98-24.683 1.963-16.33 2.298-16.665 2.01-.28 2.01-.28M29.054 55.005s-8.202 3.383-16.02 1.763"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.606,
  d: "M9.678 97.636s3.067 2.876 5.975 1.581M24.315 99.152s5.036 2.087 6.258 1.239M11.397 105.927c-.075-.019-.955-2.118-3.575-.801M12.354 104.351c-.075-.019-.955-2.118-3.575-.8M26.53 106.113s2.16-1.341 3.835.131M26.74 104.969s2.16-1.341 3.835.131M17.28 25.607l.974 1.402c.46.663 1.348.869 2.052.475l1.956-1.093M30.53 39.513s8.17 7.203 9.446 7.278 7.68-3.64 7.68-3.64M-12.454 39.442s.195 2.26 1.663 1.744M-15.792 40.848l2.38-.317M-15.952 41.941l3.175-.18M-15.177 42.832l2.722-.297M54.79 35.093s1.532.281 2.344-1.814M13.054 18.017c-.831-.21-1.675-.425-2.382-.827s-1.269-1.025-1.304-1.742.584-1.498 1.46-1.628c.601-.09 1.246.116 1.803-.102.508-.2.76-.7.741-1.15-.018-.448-.248-.862-.46-1.269-.458-.873-.858-1.86-.464-2.789s1.944-1.59 2.818-.972c.508.36.588.972.805 1.496.218.526.798 1.061 1.467.894.943-.236.81-1.456 1.584-1.968.63-.416 1.608-.14 2.024.391.417.53.427 1.213.425 1.857.43-.593.88-1.204 1.55-1.626.673-.422 1.632-.61 2.325-.272.992.485.928 1.688.574 2.624-.354.935-.88 1.95-.432 2.825.429-.991 2.327-1.29 3.072-.485.584.631.357 1.618-.318 2.242s-1.686.934-2.675 1.062M66.577 34.018s.203.669 0 1.15M68.094 34.018s.203.669 0 1.15"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeWidth: 0.681,
  d: "m19.505 20.874 2.706-.652"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#12135B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.672,
  d: "M23.414 15.062c.158.814.061 1.586.09 2.437M19.817 15.062c.123.952.222 1.585.237 2.524"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090754",
  strokeLinecap: "round",
  strokeWidth: 0.681,
  d: "m23.085 31.758-.044.51-.044.509"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8181FF",
  d: "M19.069 13.903c1.112-.11 2.138.99 2.326 2.473a.9.9 0 0 1 .284-.05.9.9 0 0 1 .261.043c.024-1.342.787-2.426 1.751-2.452.997-.026 1.83 1.093 1.86 2.5.029 1.406-.756 2.567-1.754 2.593-.85.022-1.578-.788-1.794-1.898l-.035.04-.003-.002-.022-.017a1 1 0 0 0-.084-.058.4.4 0 0 0-.18-.067.4.4 0 0 0-.18.067 1 1 0 0 0-.084.057c-.096 1.23-.812 2.205-1.777 2.3l-.21.007c-1.013-.038-1.911-1.06-2.107-2.415l-.215-.018a27 27 0 0 0-.782-.055 15 15 0 0 0-.897-.023 3.3 3.3 0 0 0-.635.05.56.56 0 0 0-.388.289.7.7 0 0 0-.069.2v.004l-.012.067a.341.341 0 0 1-.667-.12l.34.026-.34-.028V17.4l.006-.035q.005-.04.02-.103c.02-.083.057-.196.121-.316.133-.248.384-.522.828-.63.208-.05.498-.066.79-.069.3-.003.632.01.939.026a28 28 0 0 1 .924.065c.052-1.291.785-2.335 1.785-2.434m.07.677c-.303.03-.614.227-.852.626-.238.4-.374.965-.309 1.597.065.633.313 1.16.628 1.505s.66.476.963.446.615-.226.853-.626.373-.965.308-1.598c-.065-.632-.313-1.159-.628-1.503-.315-.345-.66-.477-.964-.447m4.567.019c-.22.006-.482.137-.712.477s-.386.838-.374 1.416c.012.579.19 1.07.432 1.397.244.328.511.445.73.44.22-.006.483-.137.713-.477s.386-.84.374-1.418c-.012-.579-.19-1.07-.433-1.396-.244-.328-.511-.445-.73-.44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#090754",
  d: "M23.005 20.174a.294.294 0 0 1 .42-.11.34.34 0 0 1 .112.448c-.583 1.057-1.426 1.412-2.235 1.406-.787-.007-1.529-.352-1.975-.667a.34.34 0 0 1-.093-.452.293.293 0 0 1 .424-.09c.377.265 1 .551 1.635.556.612.005 1.247-.247 1.712-1.09"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A2AC4",
  d: "M71.017-13.185a.36.36 0 0 0-.486.153c-.288.554-.622 1.499-.642 2.667a.36.36 0 0 0 .72.012c.017-1.042.316-1.878.56-2.347a.36.36 0 0 0-.152-.485M74.564-12.464a.36.36 0 0 0-.465.206c-.113.292-.278.771-.413 1.268-.13.486-.244 1.033-.227 1.442a.36.36 0 1 0 .719-.03c-.012-.29.073-.743.203-1.224.127-.47.284-.925.39-1.197a.36.36 0 0 0-.207-.465"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.167,
  stroke: "#E5E5EE",
  strokeWidth: 1.667
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "data-reporting-assistant-chat_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#fff",
  rx: 20
})))));
export default SvgDataReportingAssistantChat;